import type { FC } from "react";
import { ActivitiesListPage } from "web_myplann/Activities/Pages/ActivitiesListPage";
import { ActivitiesListV2Page } from "web_myplann/Activities/Pages/ActivitiesListV2Page";
import { useGoalsRight } from "web_myplann/Api/Rights/RightsProvider";

export const ActivitiesListPageResolver: FC = () => {
	const hasGoalsRight = useGoalsRight();

	return hasGoalsRight ? <ActivitiesListV2Page /> : <ActivitiesListPage />;
};
